import axios, { type AxiosResponse } from "axios";
import { baseUrl } from "./constants";

// Request type
export interface InitializeChatSessionRequest {
  source_entity: string;
  username: string;
  user_email: string;
}

// Response type
export interface InitializeChatSessionResponse {
  chat_session_uid: string;
}

// Axios POST request
export function initializeChatSession(
  data: InitializeChatSessionRequest,
): Promise<AxiosResponse<InitializeChatSessionResponse>> {
  return axios.post(`${baseUrl}/api/v1/quotation-request-chat/initialize`, data);
}
